import { createDrawerStore } from '../drawer/createDrawerStore';

/**
 * Stacked-drawer store for the unified `Client` CRM entity (relations-v2).
 * Replaces the legacy `useCustomerDrawerStore` (Customer was a thin wrapper
 * over `business_customer | individual_customer`; Client supports the
 * full `roles: PartyRole[]` set).
 */
export const useClientDrawerStore = createDrawerStore();
